import { Box, Button, Typography } from '@mui/material'
import { useAuth } from './AuthProvider'

/**
 * What a non-staff visitor sees. Its job is to LEAK NOTHING.
 *
 * Deliberately absent, each for the same reason — a visitor who should not know
 * this surface exists must not learn anything from the page that says no:
 *
 *   · what the tool does, or any product name beyond the wordmark
 *   · the HTTP status, the trace id, or any error detail
 *   · whether access was never granted, revoked, or expired
 *   · who to ask
 *   · navigation, the theme toggle, the INTERNO band, the build SHA
 *   · console output of any kind
 *
 * One thing is present: «Cerrar sesión». Keycloak's session is shared with the
 * product, so a browser already signed in to Fintela with another account lands
 * here on that account — and without a way out, the only exit was clearing
 * cookies. The button names nothing and is not a link: it ends the session, and
 * `SignedOutScreen` offers to sign in again, with any account.
 *
 * `<StaffOnly>` renders this for BOTH "the server said no" and "the server did
 * not answer", with the same DOM and the same copy. The two are still
 * distinguishable by timing — an error arrives on a different schedule than a
 * 200 — and pretending otherwise would be a false claim; what this removes is
 * every signal that is cheaper to read than a stopwatch.
 */
export function NoAccessScreen() {
  const { logout } = useAuth()
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <Box sx={{ textAlign: 'center', maxWidth: 320 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', mb: 1 }}>
          Fintela
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No hay nada aquí para esta cuenta.
        </Typography>
        <Button variant="outlined" size="small" onClick={logout} sx={{ mt: 3 }}>
          Cerrar sesión
        </Button>
      </Box>
    </Box>
  )
}
